import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { HttpRequest } from '@angular/common/http';

function getEndpoint(endpoint: string): string {
  const config = Configuration.get('adal');
  if (config && config.endpoints) {
    return config.endpoints[endpoint];
  }
}

export function endpointNeedsAdalToken(request: HttpRequest<any>): boolean {
  return !!getAdalEndpoint(request);
}

export function getAdalEndpoint(request: HttpRequest<any>): string {
  const adalEndpoints = Object.keys((Configuration.get('adal') || {}).endpoints || {});
  const adalEndpointId = adalEndpoints.reduce(
    (idSoFar, currentEndpoint) =>
      idSoFar || (request.url.startsWith(currentEndpoint) ? getEndpoint(currentEndpoint) : ''),
    ''
  );

  return adalEndpointId;
}
